import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';

const REVIEWS = [
  {
    id: 1,
    name: 'Sarah K.',
    location: 'Jacksonville, FL',
    service: 'Acrylic Glow Subscriber',
    quote: "Christina is a literal angel. She shows up to my house, makes me feel like a queen, and my nails always last weeks. The 3D nail art? Insane. I'll never go back to a salon.",
    stars: 5,
    image: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/i7sccqqp_20260414_154726.jpg',
  },
  {
    id: 2,
    name: 'Brittany M.',
    location: 'St. Augustine, FL',
    service: 'Gel Glow Subscriber',
    quote: "I have three kids and zero time. Monthly Glow comes to me. My nails look bomb every single month for $55. This is the best money I spend on myself.",
    stars: 5,
    image: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/ox3q0o2h_20260414_154732.jpg',
  },
  {
    id: 3,
    name: 'Tiffany R.',
    location: 'Brunswick, GA',
    service: 'Spray Tan & VIP',
    quote: "The spray tan is FLAWLESS — natural, streak-free, lasts forever. Plus everything is vegan and clean which I love. Best in the South.",
    stars: 5,
    image: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/a1efntw8_Snapchat-1296582830.jpg',
  },
  {
    id: 4,
    name: 'Ashley P.',
    location: 'Amelia Island, FL',
    service: 'Wedding Glam',
    quote: "Christina did my bridal nails, spray tan, AND makeup the morning of my wedding. She drove to the venue. Absolute lifesaver. Everyone asked who did my glam.",
    stars: 5,
    image: 'https://customer-assets.emergentagent.com/job_b78645e2-7e54-4fc5-b6dd-84c8c35b28ff/artifacts/zde6zmvq_6b956bea-9d98-4b4a-bf93-ea0486667267.png',
  },
];

const Testimonials = () => {
  return (
    <section className="py-24 bg-black/40 border-y border-amber-900/30" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-4">✦ The Glow Family ✦</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-amber-50" data-testid="testimonials-title">
            Real <span className="italic text-pink-300">reviews</span>, real glow-ups
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              viewport={{ once: true }}
              className="relative rounded-2xl border border-amber-900/30 bg-[#0a0405] p-8 overflow-hidden"
              data-testid={`review-${r.id}`}
            >
              {r.image && (
                <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full overflow-hidden border-4 border-amber-900/30 opacity-30 group-hover:opacity-50 transition-opacity">
                  <img src={r.image} alt="Client work" loading="lazy" className="w-full h-full object-cover" />
                </div>
              )}
              <Quote className="w-8 h-8 text-amber-400/40 mb-4 relative" />
              <div className="flex gap-1 mb-4 relative">
                {Array.from({ length: r.stars }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-pink-300 text-pink-300" />
                ))}
              </div>
              <p className="text-amber-100/90 leading-relaxed italic font-serif text-lg relative">"{r.quote}"</p>
              <div className="mt-6 flex items-center justify-between text-sm relative">
                <div>
                  <div className="text-amber-100 font-medium">{r.name}</div>
                  <div className="text-amber-300/60 text-xs">{r.location}</div>
                </div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-amber-300/80">{r.service}</div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link to="/book" className="inline-block px-10 py-4 rounded-full border border-amber-700/50 text-amber-100 hover:bg-amber-900/30 transition-all" data-testid="testimonials-cta">
            Become a glow story
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
